import { render, staticRenderFns } from "./MatCreateForm.vue?vue&type=template&id=550595b9&scoped=true"
import script from "./MatCreateForm.vue?vue&type=script&lang=js"
export * from "./MatCreateForm.vue?vue&type=script&lang=js"
import style0 from "./MatCreateForm.vue?vue&type=style&index=0&id=550595b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550595b9",
  null
  
)

export default component.exports